/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneTeamSettingsResponseOutputVersionMin = 0;
export const phoneTeamSettingsResponseOutputVersionMax = 9007199254740991;

export const phoneTeamSettingsResponseOutputInboundNumberOneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);
export const phoneTeamSettingsResponseOutputMessagesInboundGreetingTwoTextMax = 400;

export const phoneTeamSettingsResponseOutputMessagesInboundGreetingThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputMessagesClientCodePromptTwoTextMax = 80;

export const phoneTeamSettingsResponseOutputMessagesClientCodePromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputMessagesBeforeTransferTwoTextMax = 80;

export const phoneTeamSettingsResponseOutputMessagesBeforeTransferThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputMessagesVoicemailPromptTwoTextMax = 200;

export const phoneTeamSettingsResponseOutputMessagesVoicemailPromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputAssetsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputAssetsItemOwnerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsResponseOutputAssetsItemSizeBytesExclusiveMin = 0;
export const phoneTeamSettingsResponseOutputAssetsItemSizeBytesMax = 1048576;

export const phoneTeamSettingsResponseOutputAssetsItemDurationMsExclusiveMin = 0;
export const phoneTeamSettingsResponseOutputAssetsItemDurationMsMax = 60000;

export const phoneTeamSettingsResponseOutputAssetsItemDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const phoneTeamSettingsResponseOutputAssetsMax = 4;

export const PhoneTeamSettingsResponseOutput = zod.object({
  version: zod
    .int()
    .min(phoneTeamSettingsResponseOutputVersionMin)
    .max(phoneTeamSettingsResponseOutputVersionMax),
  inboundNumber: zod.union([
    zod.string().regex(phoneTeamSettingsResponseOutputInboundNumberOneRegExp),
    zod.null(),
  ]),
  codeRequired: zod.boolean(),
  messages: zod.object({
    inboundGreeting: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneTeamSettingsResponseOutputMessagesInboundGreetingTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneTeamSettingsResponseOutputMessagesInboundGreetingThreeAssetIdRegExp),
      }),
    ]),
    clientCodePrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneTeamSettingsResponseOutputMessagesClientCodePromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneTeamSettingsResponseOutputMessagesClientCodePromptThreeAssetIdRegExp),
      }),
    ]),
    beforeTransfer: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneTeamSettingsResponseOutputMessagesBeforeTransferTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneTeamSettingsResponseOutputMessagesBeforeTransferThreeAssetIdRegExp),
      }),
    ]),
    voicemailPrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(phoneTeamSettingsResponseOutputMessagesVoicemailPromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(phoneTeamSettingsResponseOutputMessagesVoicemailPromptThreeAssetIdRegExp),
      }),
    ]),
  }),
  teamId: zod.uuid().regex(phoneTeamSettingsResponseOutputTeamIdRegExp),
  assets: zod
    .array(
      zod.object({
        id: zod.uuid().regex(phoneTeamSettingsResponseOutputAssetsItemIdRegExp),
        ownerType: zod.enum(['team', 'customer']),
        ownerId: zod.uuid().regex(phoneTeamSettingsResponseOutputAssetsItemOwnerIdRegExp),
        slot: zod.enum([
          'inboundGreeting',
          'clientCodePrompt',
          'beforeTransfer',
          'voicemailPrompt',
        ]),
        mimeType: zod.literal('audio/mpeg'),
        sizeBytes: zod
          .int()
          .gt(phoneTeamSettingsResponseOutputAssetsItemSizeBytesExclusiveMin)
          .max(phoneTeamSettingsResponseOutputAssetsItemSizeBytesMax),
        durationMs: zod
          .int()
          .gt(phoneTeamSettingsResponseOutputAssetsItemDurationMsExclusiveMin)
          .max(phoneTeamSettingsResponseOutputAssetsItemDurationMsMax),
        digest: zod.string().regex(phoneTeamSettingsResponseOutputAssetsItemDigestRegExp),
      }),
    )
    .max(phoneTeamSettingsResponseOutputAssetsMax),
});

export type PhoneTeamSettingsResponseOutput = zod.input<typeof PhoneTeamSettingsResponseOutput>;
export type PhoneTeamSettingsResponseOutputOutput = zod.output<
  typeof PhoneTeamSettingsResponseOutput
>;
